// components/Toast.js
import React, { useEffect } from "react";

const Toast = ({ message, type, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(onClose, 3000);
    return () => clearTimeout(timer);
  }, [onClose]);

  const bgColor = type === 'success' ? 'bg-green-500' : 'bg-red-500';
  const icon = type === 'success' ? '✅' : '❌';

  return (
    <div className={`fixed top-20 right-4 p-4 rounded-lg shadow-lg z-50 ${bgColor} text-white animate-slide-in max-w-sm`}>
      <div className="flex items-center gap-2">
        <span>{icon}</span>
        <span>{message}</span>
      </div>
    </div>
  );
};

export default Toast;